import type { WeblinkUrlKey } from '@/features/interactions/addToCalendar/destinations/types';

// The feed grid speaks the weblink destinations' own url-key vocabulary, so a
// feed platform resolves straight to its destination module
// (getWeblinkDestination) — no separate mapping. The grid keeps its own
// subscription mechanics (webcal URL builders below).
export type CalendarFeedPlatform = WeblinkUrlKey;

export const allCalendarFeedPlatforms: CalendarFeedPlatform[] = [
  'apple',
  'google',
  'outlook',
  'office',
  'other',
];

export const getWebcalUrl = (url: string) =>
  url.replace(/^https?:\/\//, 'webcal://');

export const getOutlookUrl = (url: string) =>
  `https://outlook.live.com/owa/?path=/calendar/action/subscribe&url=${encodeURIComponent(url)}`;

export const getOfficeUrl = (url: string) =>
  `https://outlook.office.com/owa/?path=/calendar/action/subscribe&url=${encodeURIComponent(url)}`;

export const googleCalendarAddByUrlPage =
  'https://calendar.google.com/calendar/u/0/r/settings/addbyurl';
